import React from 'react'
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import "../../../Assets/css/watches_landing.css"
import DeskBanner from "../../../Assets/images/watches/hamilton-banner.png"
import MobileBanner from "../../../Assets/images/watches/hm-mobile.png"
import { isMobile } from 'react-device-detect'
import { Link } from "react-router-dom";
import img1 from '../../../Assets/images/watches/item1.png'
import img2 from '../../../Assets/images/watches/item2.png'
import img3 from '../../../Assets/images/watches/item3.png'
import img4 from '../../../Assets/images/watches/item4.png'
import WatchImg from "../../../Assets/images/watches/more-watch.png"
import HamiBanner from "../../../Assets/images/watches/baner_hamilton_2.png"
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Hamilton() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        accessibility: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true
                }
            },
        ]
    };
    return (
        <>
            <section>
                <div className="watches-banner-section"
                    style={{
                        backgroundImage: `url(${isMobile ? MobileBanner : DeskBanner})`,
                    }}
                >
                    <div className="watches-banner-overlay">
                        <Container>
                            <Row>
                                <Col lg={6} xs={12} className="m-auto">
                                    <div className="text-center watches-banner-content">
                                        <h2 className="watches-banner-title">American Spirit, Swiss Precision</h2>
                                        <p className="watches-banner-subtitle">
                                            Explore timeless craftsmanship with modern innovation.
                                        </p>
                                        <Button
                                            as={Link}
                                            to="/watches-list/HAMILTON" variant="light" className="watches-banner-btn">
                                            Shop Now
                                        </Button>
                                    </div>
                                </Col>
                            </Row>

                        </Container>
                    </div>
                </div>
            </section>

            <section className='novelties_section'>
                {/* Novelties Section */}
                <Container className="watches_container_ham">
                    <h2 className="title_nov">NOVELTIES</h2>

                    <Row className="g-4 justify-content-center">

                        <Col xs={12}>
                            {isMobile ? (
                                <Slider {...settings}>
                                    {[
                                        { name: "Khaki Field Mechanical Power Reserve", ImgUrl: img1 },
                                        { name: "Jazzmaster", ImgUrl: img2 },
                                        { name: "Ventura", ImgUrl: img3 },
                                        { name: "American Classic", ImgUrl: img4 },
                                    ].map((item, index) => (

                                        <div className="h-100 text-center product_item">
                                            <Card.Img
                                                variant="top"
                                                src={item.ImgUrl}
                                                alt={item.name}
                                            />
                                            <Card.Body>
                                                <Card.Title>{item.name}</Card.Title>
                                                <Button variant="outline" size="sm"
                                                    as={Link}
                                                    to="/watches-list/HAMILTON" >
                                                    Explore Now
                                                </Button>
                                            </Card.Body>
                                        </div>

                                    ))}
                                </Slider>
                            ) :
                                (
                                    <Row className="g-4 justify-content-center">
                                        {[
                                            { name: "Khaki Field Mechanical Power Reserve", ImgUrl: img1 },
                                            { name: "Jazzmaster", ImgUrl: img2 },
                                            { name: "Ventura", ImgUrl: img3 },
                                            { name: "American Classic", ImgUrl: img4 },
                                        ].map((item, index) => (
                                            <Col key={index} xs={12} sm={6} md={6} lg={3}>
                                                <div className="h-100 text-center product_item">
                                                    <Card.Img
                                                        variant="top"
                                                        src={item.ImgUrl}
                                                        alt={item.name}
                                                    />
                                                    <Card.Body>
                                                        <Card.Title>{item.name}</Card.Title>
                                                        <Button variant="outline" size="sm"
                                                            as={Link}
                                                            to="/watches-list/HAMILTON" >
                                                            Explore Now
                                                        </Button>
                                                    </Card.Body>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                )

                            }

                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='hamilton_section3'>
                <Container className="">
                    <Row className="align-items-center">
                        {/* Left Image */}
                        <Col md={6} className="mb-4 mb-md-0">
                            <img
                                src={WatchImg}
                                alt="Watch"
                                className="img-fluid rounded shadow"
                            />
                        </Col>

                        {/* Right Text */}
                        <Col md={6}>
                            <div className='hm_for_more_text'>
                                <h3 className="fw-bold">For more than 130 years</h3>
                                <p>
                                    Pioneering, practical, precise: Hamilton uses a unique combination of
                                    Swiss precision and American spirit to create distinctive, versatile
                                    watches for aficionados and style conscious individuals alike.
                                </p>
                                <p>
                                    Hamilton has a long history and has achieved numerous milestones,
                                    all of which have contributed to making Hamilton the strong,
                                    internationally renowned watch brand it is today.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='hamilt_end_banner'>
                <div className='hamilt_end_banner_img'>
                    <Link to="/watches-list/HAMILTON">    <img src={HamiBanner} alt="ham-banner" /> </Link>
                </div>
            </section>

        </>
    )
}

export default Hamilton